export default {
    "modal": {
        "buttons": {
            "ok": "OK",
            "cancel": "Cancel",
            "yes": "Yes",
            "no": "No",
            "abort": "Abort",
            "retry": "Retry",
            "ignore": "Ignore"
        },

        "confirm": {
            "title": "Confirm"
        },

        "prompt": {
            "title": "Enter a value"
        }
    }
};
